module.exports = __webpack_public_path__ + "static/media/membership.7a81c880.svg";